import { render, staticRenderFns } from "./SliceBody.vue?vue&type=template&id=cd986a54&lang=pug&"
import script from "./SliceBody.vue?vue&type=script&lang=js&"
export * from "./SliceBody.vue?vue&type=script&lang=js&"
import style0 from "./SliceBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports